import React from 'react';
import { PLPScoringProvider } from '../../hooks/usePLPScoring';
import { DesignerPage } from './DesignerPage';

export const DesignerPageContainer: React.FC = () => (
  <PLPScoringProvider value={{ featureFlag: 'designer-plp-scoring' }}>
    <DesignerPage />
  </PLPScoringProvider>
);
